import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    path$: BehaviorSubject<any> = new BehaviorSubject<any>({});

    constructor() {

    }

    /** Update the breadcrumb page path */
    update(currentPath: string) {
        this.path$.next(currentPath);
    }
}
